import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStateErrorType } from '@tink/core/src/tinkLinkErrorCodes';
import { AppStoreError, CommonError } from './app-state-errors';

export type AppStoreState = {
  error?: AppStoreError;
  redirectedCredentialsId: string;
};

const initialState: AppStoreState = {
  error: undefined,
  redirectedCredentialsId: '',
};

export type ApplicationErrorPayload = CommonError;

export type ApplicationCredentialsErrorPayload = CommonError & {
  credentialsId: string;
};

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setApplicationError: (state, action: PayloadAction<ApplicationErrorPayload>) => {
      state.error = {
        ...action.payload,
        errorType: AppStateErrorType.GENERAL_ERROR,
      };
    },
    setCredentialsError: (state, action: PayloadAction<ApplicationCredentialsErrorPayload>) => {
      state.error = {
        ...action.payload,
        errorType: AppStateErrorType.CREDENTIALS,
      };
    },
    setRedirectedCredentialsId: (state, action: PayloadAction<string>) => {
      state.redirectedCredentialsId = action.payload;
    },
  },
});

export const { setApplicationError, setCredentialsError, setRedirectedCredentialsId } =
  applicationSlice.actions;
